<template>
  <div class="w-full text-12 border-t border-hover">
    <div class="flex justify-center">
      <ButtonModule
        :text="`${text} with Google`"
        class="pl-0 pr-15 md:pr-25 border-r border-hover font-black"
        prefix="icon-google text-22 mr-15 md:mr-20"
        @click="googleLogin"
      />
      <ButtonModule
        :text="`${text} with Facebook`"
        class="pl-15 md:pl-25 font-black"
        prefix="icon-facebook text-22 mr-15 md:mr-20"
        @click="facebookLogin"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import localStorageService from '@/core/local-storage'

export default defineComponent({
  name: 'SocialAuth',
  components: { ButtonModule },

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  setup () {
    const route = useRoute()

    function facebookLogin () {
      window.location.href = `${process.env.VUE_APP_API}/api/auth/oauth/facebook`

      if (route.query.planId) {
        localStorageService.setItem('planId', route.query.planId)
      }
    }

    function googleLogin () {
      window.location.href = `${process.env.VUE_APP_API}/api/auth/oauth/google`

      if (route.query.planId) {
        localStorageService.setItem('planId', route.query.planId)
      }
    }

    return {
      // function
      facebookLogin,
      googleLogin
    }
  }
})
</script>
